(function () {
  if (window.__up2ViewRiseBound) return;
  window.__up2ViewRiseBound = true;

  var pending = [];

  function reducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  }

  function show(el) {
    if (!el || el.classList.contains('is-in')) return;
    el.classList.add('is-in');
  }

  function visible(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 24 && rect.top < window.innerHeight - 8;
  }

  function collect(root) {
    var scope = root instanceof Element ? root : document;
    if (scope.classList && scope.classList.contains('up2-view-rise')) pending.push(scope);
    scope.querySelectorAll('.up2-view-rise').forEach(function (el) {
      pending.push(el);
    });
    pending = pending.filter(function (el, index) {
      return pending.indexOf(el) === index && !el.classList.contains('is-in');
    });
  }

  function tick() {
    if (!pending.length) return;
    var rest = [];
    pending.forEach(function (el) {
      if (!el.isConnected) return;
      if (reducedMotion() || visible(el)) {
        show(el);
        return;
      }
      rest.push(el);
    });
    pending = rest;
  }

  function start() {
    collect(document);
    if (reducedMotion()) {
      pending.forEach(show);
      pending = [];
      return;
    }

    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    document.addEventListener('shopify:section:load', function (event) {
      collect(event.target);
      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
